import { SyntheticEvent, useState } from "react";
import FocusLock from "react-focus-lock";
import { Button, Icon, TextInput } from "@/shared/ui";

type Props = {
  onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void;
  email: string;
  error?: string;
  pending?: boolean;
};

export default function PlayerMenuSettingsSafetyEnableTfaEmailSend({
  onSubmit,
  email,
  error = "",
  pending = false,
}: Props) {
  const [touch, setTouch] = useState(false);

  return (
    <FocusLock className="contents">
      <form
        noValidate
        onSubmit={(e) => {
          onSubmit(e);
          setTouch(true);
        }}
        className="gap-3 grow flex flex-col h-full"
      >
        <div>
          <div className="text-white text-16 font-medium">
            E-mail адрес для отправки проверочного кода
          </div>
          <div className="text-white/60 text-15 font-medium mt-1">
            Отправим код подтверждения на почту указанную при регистрации
          </div>
        </div>
        <TextInput
          type="text"
          placeholder="example@mail.com"
          value={email}
          icon={<Icon name="mail" className="w-4.5" />}
          invalid={touch && !email ? "Введите почту" : ""}
          onChange={() => {}}
          className="text-center"
          loading={pending}
          disabled
        />
        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button submit className="w-full" loading={pending}>
            Отправить код
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}
